<div class="comment-ai-assist-toolbar">
	<div class="comment-ai-assist-toolbar__actions">
		@if (aiAssistAvailable) {
			<button
				type="button"
				class="comment-ai-assist-toolbar__icon-btn"
				[disabled]="!canRephrase"
				aria-label="Rephrase comment in English"
				(click)="onRephrase()"
			>
				<span class="comment-ai-assist-toolbar__pencil-icon">
					<span class="aa-mat-icon">edit</span>
					<span class="aa-mat-icon comment-ai-assist-toolbar__sparkle">auto_awesome</span>
				</span>
			</button>
		}

		@if (showMic) {
			<button
				type="button"
				class="comment-ai-assist-toolbar__icon-btn"
				[class.comment-ai-assist-toolbar__icon-btn--listening]="isListening"
				[disabled]="!canToggleListen"
				[attr.aria-pressed]="isListening"
				[attr.aria-label]="micAriaLabel"
				(click)="onMicToggle()"
			>
				<span class="aa-mat-icon">mic</span>
			</button>
		}

		<span class="comment-ai-assist-toolbar__hint">{{ hintText }}</span>
	</div>

	<button
		type="button"
		class="comment-ai-assist-toolbar__replace-btn aa-btn"
		data-variant="tertiary"
		data-size="small"
		[disabled]="!canReplace"
		(click)="onReplace()"
	>
		Save
	</button>
</div>
